import React, { useEffect, useRef, useState } from "react";
import PinPointButtons from "./PinPointButtons";
import {
  Viewer,
  // Entity,
  Cesium3DTileset,
  // KmlDataSource,
  GeoJsonDataSource,
  // ImageryLayer,
  CameraFlyTo,
} from "resium";
import {
  Color as CesiumColor,
  Rectangle,
  BingMapsImageryProvider,
  BingMapsStyle,
  // VerticalOrigin,
  // PolylineOutlineMaterialProperty,
  // Cesium3DTileFeature,
  // Resource,
  // defined,
  CesiumTerrainProvider,
  IonResource,
  // WebMapServiceImageryProvider,
  // WebMapTileServiceImageryProvider,
  // GeographicTilingScheme,
  Ion,
  // PinBuilder,
  // Cartesian2,
  // Cartesian3,
  // HeightReference,
  // Math,
  // formatError,
} from "cesium";
import Layers from "./GeoJsonData/Layers";
function CesiumViewer(props) {
  //Using this ref to communicate the state of the hide/show button
  const hideShowDataRef = useRef();

  // const [firstTime, setFirstTime] = useState(true)
  // useEffect(()=>{
  //   setFirstTime(false)
  // })
  Ion.defaultAccessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJkYWYxYzE1OS00MGIzLTQ1ZTUtODQ3ZC00MGU2NzU5NmEyMmYiLCJpZCI6NDQwMzEsImlhdCI6MTYxMzU0NTczM30.9tSm4HrH8O3hj3u19kqFHWhgdAOj59IDir8IYwxUtTE";

  const terrainProvider = new CesiumTerrainProvider({
    url: IonResource.fromAssetId(1), // 437958
  });
  return (
    <Viewer
      onClick={props.handleClick}
      ref={props.viewerRef}
      terrainProvider={terrainProvider}
    >
    <Cesium3DTileset url={IonResource.fromAssetId(96188)} />
      <CameraFlyTo
        destination={Rectangle.fromDegrees(
          -97.6141,
          49.9401,
          -96.8601,
          50.8549
        )}
      />
      <Layers hideShowDataRef={hideShowDataRef} />

      <PinPointButtons
        hideShowDataRef={hideShowDataRef}
        addPinPointsButtonClickedRef={props.addPinPointsButtonClickedRef}
        updatePinPointsButtonClickedRef={props.updatePinPointsButtonClickedRef}
        deletePinPointsButtonClickedRef={props.deletePinPointsButtonClickedRef}
      />
    </Viewer>
  );
}

export default CesiumViewer;
